module.exports = __webpack_public_path__ + "img/3-cartoon-content.ff836cd8.jpg";